import {isMeaningful} from "@/utils/common";
import router from "@/router";
export {drag} from './drag.js';

/** 
 * 自定义指令  传入对象 设置元素自身的margin值 传入数值 设置子项的margin-left 和margin-right的值
 * @example 
 * v-gutter="8" 或者 v-gutter="{top:1,left:1,right:1,bottom:1}"
 */
export const gutter = {
  componentUpdated: _gutter,
  bind: _gutter,
  // update: _gutter,
};

function _gutter(el, {value}) {
  const style = {};
  const objectValue = typeof value === 'object';
  let ignore = 'first';
  if (objectValue) {
    if (value.top) {
      style['margin-top'] = `${value.top}px`;
    }
    if (value.bottom) {
      style['margin-bottom'] = `${value.bottom}px`;
    }
    if (value.left) {
      style['margin-left'] = `${value.left}px`;
      style['margin-right'] = '0px';
    } else if (value.right) {
      style['margin-left'] = '0px';
      style['margin-right'] = `${value.right}px`;
    }
    if (value.ignore) {
      ignore = value.ignore;
    }
  } else {
    style['margin-left'] = `${value}px`;
    style['margin-right'] = `0px`;
  }
  if (isMeaningful(el) && isMeaningful(el.children)) {
    const length = el.children.length;
    try {
      for(let index = 0; index < length; index++) {
        let item = el.children[index]
        if (ignore === 'first' && index === 0) {
          continue;
        }
        if (ignore === 'last' && index === length - 1) {
          style['margin-left'] = `0px`;
          style['margin-right'] = `0px`;
          continue;
        }
        for (let key in style) {
          item.style[key] = style[key];
        }
      }

      // el.children.forEach((item,index) => {
      //   if (ignore === 'first' && index === 0) {
      //     return;
      //   }
      //   if (ignore === 'last' && index === length - 1) {
      //     style['margin-left'] = `0px`;
      //     style['margin-right'] = `0px`;
      //     return;
      //   }
      //   for (let key in style) {
      //     item.style[key] = style[key];
      //   }
      // })
    } catch(err) {
    }
  }
}

export const adaptHeight = {
  bind: function (el, {value: {setHeight, offsetTo}}) {
    elAdaptHeight(el, setHeight, offsetTo);
    if (!el.$adaptHeightCallback) {
      el.$adaptHeightCallback = () => elAdaptHeight(el, setHeight, offsetTo);
      window.addEventListener('resize', el.$adaptHeightCallback);
    }
  },
  inserted: function (el, {value: {setHeight, offsetTo}}) {
    elAdaptHeight(el, setHeight, offsetTo);
  },
  //TODO:  listenUpdate：表格高度计算错误，临时解决方案，有时间需要调整系统中的全部表格
  update: function (el, {value: {setHeight, offsetTo, listenUpdate}}) {
    if (listenUpdate) {
      elAdaptHeight(el, setHeight, offsetTo);
    }
  },
  unbind: function (el) {
    window.removeEventListener('resize', el.$adaptHeightCallback);
  }
};

function elAdaptHeight(el, setHeight, offsetTo) {
  if (offsetTo === 'window') {
    const offsetClientTop = el.getBoundingClientRect().top;
    setHeight(document.documentElement.clientHeight - offsetClientTop);
  } else if (offsetTo === 'parent') {
    const parentElement = el.parentElement;
    if (isMeaningful(parentElement)) {
      const offsetHeight = parentElement.offsetHeight
        - (parentElement.clientTop - parentElement.firstElementChild.clientTop);
      setHeight(offsetHeight);
    }
  }
}

// copy指令简写
export const copy = function (el, {value, callback}, vnode) {
  if (el.$copyCallback) {
    el.removeEventListener('click', el.$copyCallback);
  }
  el.$copyCallback = () => _copy(value, callback, vnode);
  el.addEventListener("click", el.$copyCallback);
}



function _copy(value, callback, vnode) {
  // 没有内容可复制，直接return
  if (!value) return
  const input = document.createElement("input");   // 直接构建input
  input.value = value;  // 设置内容
  document.body.appendChild(input);    // 添加临时实例
  input.select();   // 选择实例内容
  document.execCommand("Copy");   // 执行复制
  document.body.removeChild(input); // 删除临时实例
  if (callback && typeof callback === 'function') {
    callback();
  } else {
    vnode.context.$gjMessage.closeAll();
    vnode.context.$gjMessage.success('复制成功');
  }
}

export function flex(el, {value: {height, direction}}) {
  if (isMeaningful(el)) {
    el.style['display'] = 'flex';
    el.style['flex-direction'] = direction || 'column';
    el.style['height'] = height || '100%';
  }
}

export const recordScroll = {
  bind: (el) => {
    let curRoute = null;
    let scrollTop = null;
    router.beforeEach((to, from, next) => {
      if (curRoute === null) {
        curRoute = from.path;
      }
      if (curRoute === from.path) {
        scrollTop = el.scrollTop;
      }
      next();
    });
    router.afterEach((to, from) => {
      if (curRoute === to.path) {
        setTimeout(() => {
          el.scrollTop = scrollTop;
        });
      }
    });
  }
};

//价格
function priceValidate(input, e) {
  if (!/^[1-9][0-9]*[.]?[0-9]{0,2}$/.test(input.value)) {
    input.value = input.value.match(/^[0-9]*[.]?[0-9]{0,2}/);
  }
}

//可为负数 2位小数
function toFixed2Validate(input, e) {
    input.value = input.value.match(/^[-]?[0-9]*[.]?[0-9]{0,2}/);
}

//价格 4位小数
function toFixed4Validate(input, e) {
  if (!/^[1-9][0-9]*[.]?[0-9]{0,4}$/.test(input.value)) {
    input.value = input.value.replace(',', '').match(/^[0-9]*[.]?[0-9]{0,4}/);
  }
}
//整数
function integerValidate(input, e) {
  input.value = input.value.match(/^-?[1-9][0-9]*$/);
}

//正整数
function positiveValidate(input, e) {
  if (!/^[1-9][0-9]*[.]?[0-9]$/.test(input.value)) {
    input.value = input.value.match(/^[1-9][0-9]*/);
  }
}
export const number ={
  bind(el, binding) {
    let {price, toFixed2, toFixed4, positive, int} = binding.modifiers;
    const input = el.getElementsByTagName('input')[0];
    input.onkeyup = function (e) {
      price && priceValidate(input, e);
      toFixed2 && toFixed2Validate(input, e);
      toFixed4 && toFixed4Validate(input, e);
      positive && positiveValidate(input, e);
      int && integerValidate(input, e);
      trigger(input, 'input')
    }
    input.onblur = function (e) {
      price && priceValidate(input, e);
      toFixed2 && toFixed2Validate(input, e);
      toFixed4 && toFixed4Validate(input, e);
      positive && positiveValidate(input, e);
      int && integerValidate(input, e);
      trigger(input, 'input')
    }
  }
}

const trigger = (el, type) => {
  const e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e)
};


